import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

import Button from 'components/Button';

import * as Actions from '../loginActions';
import stateReady from 'assets/img/state-ready.svg';
import './styles.scss';

class Reset extends Component {
  activeAccount = () => {
    this.props.addLoginData({ reset: undefined });
    this.context.router.push(`/code`);
  }

  render() {
    return (
      <div className='Unauthorized'>
        <img src={stateReady} alt='image ready' />
        <h2 className='Unauthorized__success'>Código enviado correctamente</h2>
        <p>Tu código fue enviado de forma correcta.</p>
        <Button onClick={this.activeAccount} variant='contained' color='secondary'>Continuar</Button>
      </div>
    );
  }
}

Reset.contextTypes = { 
  router: PropTypes.shape()
};

Reset.propTypes = {};

const mapDispatchToProps = dispatch => bindActionCreators(Actions, dispatch);
const mapStateToProps = state => ({
  loginState: state.get('loginState'),
});

export default connect(mapStateToProps, mapDispatchToProps)(Reset);
